import $ from 'cash-dom';
import RegionService from '../services/RegionService';

const REGION_STORAGE_KEY = '@setpar:regionByLocation';

const RegionTabs = {
  button: {
    targetAttribute: 'data-target',
    activeClass: 'active',
    selector: region => (region ? `[data-target=${region}]` : '[data-target]'),
  },
  buttonsContainer: {
    selector: '[data-region-nav]',
  },
  container: {
    element: null,
    selector: '[data-component=RegionTabs]',
  },
  header: {
    selector: '[data-region-header]',
  },
  section: {
    headerSelector: region => `[data-section-header=${region}]`,
    containerSelector: '[data-section-container]',
    selector: region =>
      region ? `[data-section=${region}]` : `[data-section]`,
    activeClass: 'is-active',
  },
  isSelectedByLocation: false,
  hasRegion: region => {
    const regionSelector = RegionTabs.section.selector(region);
    const searchRegion = RegionTabs.container.element.find(regionSelector);
    return Boolean(searchRegion.length);
  },
  activeRegionByLocation: region => {
    if (RegionTabs.hasRegion(region)) {
      RegionTabs.moveRegionButtonToFirst(region);
      RegionTabs.moveRegionToFirst(region);

      RegionTabs.activeTab(region);
      RegionTabs.isSelectedByLocation = true;

      RegionTabs.updateHeaderSection(region);
    }
  },
  updateHeaderSection: region => {
    const header = $(RegionTabs.section.selector(region));
    header.prepend(`
      <div class="px-3 px-lg-0">
        <div class="px-0 px-lg-3 col-lg-7 mx-auto alert alert-info text-center align-items-center d-flex justify-content-center py-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="mr-1 mr-lg-2" width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        Exibindo terrenos próximos de você
        </div>
      </div>
    `);
  },
  findButtonByRegion: region => {
    return RegionTabs.container.element.find(
      RegionTabs.button.selector(region)
    );
  },
  findSectionByRegion: region => {
    return RegionTabs.container.element.find(
      RegionTabs.section.selector(region)
    );
  },
  moveRegionToFirst: region => {
    const sectionContainer = RegionTabs.container.element.find(
      RegionTabs.section.containerSelector
    );
    const section = RegionTabs.findSectionByRegion(region);
    const sectionHeader = sectionContainer.find(
      RegionTabs.section.headerSelector(region)
    );

    sectionContainer.remove(sectionHeader);
    sectionContainer.remove(section);

    sectionContainer.prepend(section);
    sectionContainer.prepend(sectionHeader);
  },
  moveRegionButtonToFirst: region => {
    const buttonWithContainer = RegionTabs.findButtonByRegion(region).parent();
    RegionTabs.container.element.remove(buttonWithContainer);
    RegionTabs.container.element
      .find(RegionTabs.buttonsContainer.selector)
      .prepend(buttonWithContainer);
  },
  activeTab: target => {
    RegionTabs.container.element
      .find(RegionTabs.button.selector())
      .removeClass(RegionTabs.button.activeClass);
    $(RegionTabs.button.selector(target)).addClass(
      RegionTabs.button.activeClass
    );

    RegionTabs.container.element
      .find(RegionTabs.section.selector())
      .removeClass(RegionTabs.section.activeClass);
    const sectionToActive = $(RegionTabs.section.selector(target));
    sectionToActive.addClass(RegionTabs.section.activeClass);
  },
  initTabs: () => {
    RegionTabs.container.element
      .find(RegionTabs.button.selector())
      .each(function(_, buttonElement) {
        $(buttonElement).on('click', function() {
          const button = $(this);
          const target = button.attr(RegionTabs.button.targetAttribute);

          RegionTabs.activeTab(target);
        });
      });
  },
  initRegionByLocation: () => {
    const regionFromStorage = window.localStorage.getItem(REGION_STORAGE_KEY);
    if (regionFromStorage) {
      RegionTabs.activeRegionByLocation(regionFromStorage);
      return;
    }

    if (
      !regionFromStorage &&
      !RegionTabs.isSelectedByLocation &&
      'geolocation' in navigator
    ) {
      navigator.geolocation.getCurrentPosition(position => {
        const { latitude, longitude } = position.coords;

        const onComplete = region => {
          window.localStorage.setItem(REGION_STORAGE_KEY, region);
          RegionTabs.activeRegionByLocation(region);
        };

        RegionService.fetchRegionByCoordinates({
          latitude,
          longitude,
          onComplete,
        });
      });
    }
  },
  init: () => {
    $(function() {
      RegionTabs.container.element = $(RegionTabs.container.selector);
      RegionTabs.initTabs();
      RegionTabs.initRegionByLocation();
    });
  },
};

export default RegionTabs;
